import EventBus from '../../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'
import '../../../../shared/js/components/file-upload'
import '../../../../shared/js/utilities/loading-animation'

class SurveyDocuments {
    
    /**
     * Construct module
     * @param input
    */
    constructor(input) {
        
        /**
         * File input
         * @type object
        */
        this.input = input
        
        /**
         * List of uploaded documents
         * @type object
        */
        this.uploadedList = jQuery('#survey-documents')
        
        /**
         * Comments form
         * @type object
        */
        this.form = jQuery('#comments-survey-form')

        this.bindEvents()
        
    }
    
    /**
     * Upload success
     * @param event
     * @param data
    */
    uploadSuccess(event, data) {
        
        //Append uploaded files to list HTML
        
        var html = ''

        jQuery.each(data.response.uploaded, (id, filename) => {
            html += `
                <li class="list-inline-item badge badge-pill badge-secondary mb-2">
                    <button class="btn btn-link text-primary btn-sm delete" type="button" data-id="${id}">
                        <i class="icon-cancel" aria-hidden="true"></i>
                    </button>
                    <span class="mr-2">${filename}</span>
                </li>
            `
        })
        
        this.uploadedList.css('display', '').append(html)
        
    }
    
    /**
     * Delete upload
     * @param event
    */
    deleteUpload(event) {
        
        //Get clicked button
        const clicked = jQuery(event.currentTarget)
        
        //Apply loading animation to form
        EventBus.publish('loading.start', this.form)
        
        //Send request to server
        jQuery.post(this.uploadedList.data('delete-url').replace('-1', clicked.data('id')), () => {
            
            //Remove document from list
            clicked.closest('li').remove()
            
        }).always(() => {
            
            //Remove loading animation from form
            EventBus.publish('loading.stop', this.form)
            
        })
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Bind upload successful event
        this.input.on('filebatchuploadsuccess', this.uploadSuccess.bind(this))
        
        //Bind delete button click
        this.uploadedList.on('click', '.delete', this.deleteUpload.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    const input = jQuery('#survey-documents-upload')
    
    if (input.length > 0) {
        new SurveyDocuments(input)
    }
    
})

export default SurveyDocuments